// Rastreia cada visualização de página chamando POST /api/track.
//
// - Ignora a área administrativa (/painel).
// - Deduplica por sessão (sessionStorage) para que recarregar a mesma página não
//   conte como novo acesso.
// - Detecta /blog/:slug para enviar o slug do post.
// - Envia o flag de consentimento (cookie hl_vid só é criado no backend se true).

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../services/api";
import { getConsentLevel, isTrackingAllowed } from "../utils/consent";
import { safeGet, safeSet } from "../utils/safeStorage";

const TRACKED_KEY = "hl_tracked_paths";

function alreadyTracked(path) {
    try {
        const raw = safeGet(TRACKED_KEY, { kind: "session" });
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) && list.includes(path);
    } catch {
        return false;
    }
}

function markTracked(path) {
    try {
        const raw = safeGet(TRACKED_KEY, { kind: "session" });
        const list = raw ? JSON.parse(raw) : [];
        if (Array.isArray(list) && !list.includes(path)) {
            list.push(path);
            safeSet(TRACKED_KEY, JSON.stringify(list), { kind: "session" });
        }
    } catch {
        /* ignora falhas de storage */
    }
}

function postSlugFromPath(path) {
    const match = path.match(/^\/blog\/([^/]+)\/?$/);
    return match ? decodeURIComponent(match[1]) : null;
}

export default function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        if (path.startsWith("/painel")) return;
        if (alreadyTracked(path)) return;

        markTracked(path);
        trackPageView({
            path,
            postSlug: postSlugFromPath(path),
            referrer: typeof document !== "undefined" ? document.referrer : "",
            consent: isTrackingAllowed(),
            consentLevel: getConsentLevel(),
        }).catch(() => {
            /* tracking nunca deve quebrar a navegação */
        });
    }, [location.pathname]);
}
